import _objectWithoutProperties from '../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import React from 'react';
import Icon from '../components/Icon/Icon.js';

var IconSuccess = function IconSuccess(_ref) {
  var title = _ref.title,
      filled = _ref.filled,
      otherProps = _objectWithoutProperties(_ref, ["title", "filled"]);

  return /*#__PURE__*/React.createElement(Icon, otherProps, filled ? /*#__PURE__*/React.createElement("svg", {
    title: title,
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0c13.255 0 24 10.745 24 24S37.255 48 24 48 0 37.255 0 24 10.745 0 24 0zm11.561 16.439a1.5 1.5 0 00-2.007-.103l-.114.103-12.902 12.902-5.94-6.365-.111-.107a1.5 1.5 0 00-2.182 2.037l.099.117 7 7.5.106.103a1.5 1.5 0 001.941.034l.11-.1 14-14 .103-.114a1.5 1.5 0 00-.103-2.007z"
  })) : /*#__PURE__*/React.createElement("svg", {
    title: title,
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0c13.255 0 24 10.745 24 24S37.255 48 24 48 0 37.255 0 24 10.745 0 24 0zm0 3C12.421 3 3 12.42 3 24s9.42 21 21 21c11.579 0 21-9.42 21-21S35.58 3 24 3zm11.561 13.439a1.5 1.5 0 01.103 2.007l-.103.114-14 14a1.5 1.5 0 01-2.051.066l-.106-.103-7-7.5a1.5 1.5 0 012.083-2.154l.11.107 5.94 6.365L33.44 16.44a1.5 1.5 0 012.12 0z"
  })));
};

export default IconSuccess;
